module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('TopNav'), _vm._v(" "), _c('NodeInfo'), _vm._v(" "), _c('div', {
    staticClass: "main-container-wrapper"
  }, [_c('div', {
    staticClass: "description text-center"
  }, [_c('h1', [_vm._v("IPFS Browser Stream Benchmarks")]), _vm._v(" "), _c('p', [_vm._v("A small utility to test ipfs's get streaming performance (especially for large files) and see some metrics.")]), _vm._v(" "), _c('p', [_vm._v(" Choose one of the preselected files below or test with a custom one.")]), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.status === 'stopped') ? _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.startNode
    }
  }, [_vm._v("Start your node")]) : _vm._e()], 1), _vm._v(" "), _c('el-tabs', {
    model: {
      value: (_vm.activeTab),
      callback: function($$v) {
        _vm.activeTab = $$v
      },
      expression: "activeTab"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "87 kB",
      "name": "first"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/poster.jpg'),
      "hash": "QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/poster.jpg"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "1 MB",
      "name": "second"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTca4A43f4kEvzTouvYTegtp6KobixRqweV12NrvwwtFP'),
      "hash": "QmTca4A43f4kEvzTouvYTegtp6KobixRqweV12NrvwwtFP"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "22 MB",
      "name": "third"
    }
  }, [_c('Stream', {
    attrs: {
      "peers": _vm.peers,
      "nodeStatus": _vm.status,
      "benchmarks": _vm.getBenchmarkByHash('QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/video.webm'),
      "hash": "QmTKZgRNwDNZwHtJSjCp6r5FYefzpULfy37JvMt9DwvXse/video.webm"
    },
    on: {
      "submit": _vm.getFile
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Using the official IPFS ("), _c('a', {
    attrs: {
      "href": "https://github.com/ipfs/js-ipfs",
      "target": "_blank"
    }
  }, [_vm._v("js-ipfs")]), _vm._v(") v0.26.0")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2b524738","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 909
// module chunks = 1